<template>
  <div>
    <data-detail-row
      :oldValueData="oldValue('company_name') != false"
      :data="data"
      :label="'Nama Perusahaan'"
      :valueData="data.company_name"
      :oldData="oldValue('company_name')"
    />
    <data-detail-row
      :oldValueData="oldValue('owner_name') != false"
      :data="data"
      :label="'Nama Pemilik Usaha'"
      :valueData="data.owner_name"
      :oldData="oldValue('owner_name')"
    />
    <data-detail-row
      :oldValueData="oldValue('account_number') != false"
      :data="data"
      :label="'Nomor Rekening Perusahaan'"
      :valueData="data.account_number"
      :oldData="oldValue('account_number')"
    />
    <data-detail-row
      :oldValueData="oldValue('ktp_no') != false"
      :data="data"
      :label="'Nomor KTP Pemilik Usaha'"
      :valueData="text(data.ktp_no)"
      :oldData="oldValue('ktp_no')"
    />
    <data-detail-row
      :oldValueData="oldValue('npwp_no') != false"
      :data="data"
      :label="'Nomor NPWP Perusahaan'"
      :valueData="data.npwp_no"
      :oldData="oldValue('npwp_no')"
    />
    <data-detail-row
      :oldValueData="
        oldValue('phone_area_code') != false || oldValue('phone') != false
      "
      :data="data"
      :label="'Nomor Telepon'"
      :valueData="merchantPhone == ' ' ? '( not set )' : merchantPhone"
      :oldData="
        oldValue('phone_area_code') != false || oldValue('phone') != false
          ? convertMerchantPhone(
              data.old_value.phone_area_code,
              data.old_value.phone
            )
          : ''
      "
    />
    <data-detail-row
      :oldValueData="oldValue('email') != false"
      :data="data"
      :label="'Email'"
      :valueData="data.email"
      :oldData="oldValue('email')"
    />
    <data-detail-row
      :oldValueData="oldValue('address') != false"
      :data="data"
      :label="'Alamat Perusahaan'"
      :valueData="data.address"
      :oldData="oldValue('address')"
    />
    <data-detail-row
      :oldValueData="
        oldValue('kabupaten_kota') != false ||
        oldValue('kecamatan') != false ||
        oldValue('kode_pos_id') != false
      "
      :data="data"
      :label="'Kota, Kecamatan, Kode Poss'"
      :valueData="
        data.kabupaten_kota + ', ' + data.kecamatan + ', ' + data.kode_pos_id
      "
      :oldData="
        oldValue('kabupaten_kota') != false ||
        oldValue('kecamatan') != false ||
        oldValue('kode_pos_id') != false
          ? getOldValue('kabupaten_kota') +
            ', ' +
            getOldValue('kecamatan') +
            ', ' +
            getOldValue('kode_pos_id')
          : ''
      "
    />
    <data-detail-row
      :oldValueData="regionalMappingOldValueExists('bcko')"
      :data="data"
      :label="'KODE BC/KO'"
      :valueData="text(data.bcko)"
      :oldData="regionalMappingOldValueText('bcko')"
    />
    <data-detail-row
      :oldValueData="regionalMappingOldValueExists('cmer')"
      :data="data"
      :label="'Merchant Category Segment'"
      :valueData="text(data.cmer)"
      :oldData="regionalMappingOldValueText('cmer')"
    />
    <data-detail-row
      :oldValueData="regionalMappingOldValueExists('referral_code')"
      :data="data"
      :label="'Referral Code'"
      :valueData="text(data.referral_code)"
      :oldData="regionalMappingOldValueText('referral_code')"
    />

    <v-card
      class="mb-12"
      height="20px"
      :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
    >
      <div class="d-flex pa-5 flex-column align-center justify-center">
        <h3>Endpoint</h3>
      </div>
    </v-card>
    <data-detail-row
      :oldValueData="oldValue('endpoint') != false"
      :data="data"
      :label="'URL'"
      :valueData="text(data.endpoint)"
      :oldData="oldValue('endpoint')"
    />
    <data-detail-row
      :oldValueData="oldValue('ip_address') != false"
      :data="data"
      :label="'IP Address'"
      :valueData="text(data.ip_address)"
      :oldData="oldValue('ip_address')"
    />
    <!-- SNAP Fields -->
    <data-detail-row
      v-if="isApiSnap"
      :oldValueData="oldValue('client_version') != false"
      :data="data"
      :label="'Client Version'"
      :valueData="text(data.client_version)"
      :oldData="oldValue('client_version')"
    />
    <data-detail-row
      v-if="isApiSnap"
      :oldValueData="oldValue('access_token_endpoint') != false"
      :data="data"
      :label="'Callback Partner URL Token'"
      :valueData="text(data.access_token_endpoint)"
      :oldData="oldValue('access_token_endpoint')"
    />
    <data-detail-row
      v-if="isApiSnap"
      :oldValueData="oldValue('cred_client_id') != false"
      :data="data"
      :label="'Callback Partner ID'"
      :valueData="text(data.cred_client_id)"
      :oldData="oldValue('cred_client_id')"
    />
    <data-detail-row
      v-if="isApiSnap"
      :oldValueData="oldValue('client_secret') != false"
      :data="data"
      :label="'Client Secret'"
      :valueData="text(data.client_secret)"
      :oldData="oldValue('client_secret')"
    />
    <v-row v-if="isApiSnap" style="align-items: flex-start">
      <v-col cols="10" sm="4">Public Key Partner</v-col>
      <v-col cols="2" sm="1">:</v-col>
      <v-col cols="12" sm="7">
        <div class="public-key-container">
          <v-textarea
            :value="decryptedPublicKey"
            readonly
            outlined
            dense
            rows="4"
            class="fixed-height-textarea"
          />
          <v-btn
            icon
            small
            class="copy-btn"
            @click="copyPublicKey"
            title="Copy Public Key"
          >
            <v-icon small>mdi-content-copy</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <data-detail-row
      :oldValueData="oldValue('approver_1') != false"
      :data="data"
      :label="'ID Approver 1'"
      :valueData="data.approver_1"
      :oldData="oldValue('approver_1')"
    />
    <data-detail-row
      :oldValueData="oldValue('approver_2') != false"
      :data="data"
      :label="'ID Approver 2'"
      :valueData="data.approver_2"
      :oldData="oldValue('approver_2')"
    />
  </div>
</template>

<script>
import { text } from '../../lib/helpers';
import decryptAES256GCM from '../../lib/utils/decryptAES';
import { dataListMerchantCriteria } from '../../store/params';
import regionalMappingOldValueMixin from './regionalMappingOldValueMixin';

export default {
  mixins: [regionalMappingOldValueMixin],
  components: { DataDetailRow: () => import('./DataDetailRow.vue') },
  props: ['data'],
  data() {
    return {
      merchant_type: 'Merchant',
      loadingSave: false,
      // qrisFile: null,
      dialog: false,
      dialogReject: false,
      dialogSendback: false,
      loading: false,
      remark: '',
      idTaskAdd: ['0', '2', '3'],
      idTaskEdit: ['4', '5', '6', '14'],
      criteriaMerchantText: dataListMerchantCriteria,
    };
  },
  computed: {
    isCloseMerchant() {
      return this.data != null && this.data.task_type_id.toString() == '7';
    },

    isTypeSettlement() {
      return this.data != null && this.data.task_type_id.toString() == '15';
    },
    merchantPhone() {
      const area =
        this.data.phone_area_code != '' && this.data.phone_area_code != null
          ? `(${this.data.phone_area_code})`
          : '';
      const phone = this.data.phone != null ? this.data.phone : '';
      return `${area} ${phone}`;
    },
    accountType() {
      return this.data != null ? this.data.account_type : null;
    },
    merchantTypeId() {
      if (this.data != null) {
        if (this.data.merchant_type_id != null) {
          return this.data.merchant_type_id;
        }
        return '1';
      }
      return '1';
    },
    isApiSnap() {
      if (this.data == null) return false;
      return this.data.id_qr_type == 2 && this.data.client_version === 'SNAP';
    },
    decryptedPublicKey() {
      if (!this.isApiSnap || !this.data.public_key_inbound) return '';
      try {
        return decryptAES256GCM(this.data.public_key_inbound);
      } catch (e) {
        return this.data.public_key_inbound;
      }
    },
  },
  methods: {
    oldValue(variable) {
      if (
        this.data.old_value != null &&
        this.data.old_value[variable] != null &&
        this.data[variable] != this.data.old_value[variable]
      ) {
        return this.data.old_value[variable];
      }
      return false;
    },
    getOldValue(variable) {
      return this.data.old_value[variable];
    },

    convertMerchantPhone(phoneAreaCode, phone) {
      const area =
        phoneAreaCode != '' && phoneAreaCode != null
          ? `(${phoneAreaCode})`
          : '';
      const phoneText = phone != null ? phone : '';
      return `${area} ${phoneText}`;
    },
    tipeMerchantText(textVal) {
      return textVal.toLowerCase() == 'corporate' ? 'Badan Usaha' : textVal;
    },
    criteriaText(value) {
      const find = this.criteriaMerchantText.find((x) => value == x.value);
      return find != undefined ? find.text : value;
    },
    text,
    copyPublicKey() {
      const textToCopy = this.decryptedPublicKey;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy).then(() => {
          this.$toast.success('Public Key copied to clipboard');
        });
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        this.$toast.success('Public Key copied to clipboard');
      }
    },
  },
};
</script>

<style scoped>
.fixed-height-textarea {
  font-family: monospace;
  font-size: 12px;
}
.fixed-height-textarea >>> .v-input__slot {
  min-height: 100px !important;
}
.fixed-height-textarea >>> textarea {
  min-height: 80px !important;
  line-height: 1.4;
}
.public-key-container {
  position: relative;
  width: 100%;
}
.copy-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(255, 255, 255, 0.9);
}
</style>
